export const SKILL_GROUP_ICONS = {
  Research: 'flask-conical',
  Prospect: 'user',
  Engage: 'mail-warning',
  Skills: 'handshake',
  'Dev Only': 'code-browser',
}

export function groupSkills(skills) {
  const groups = new Map()

  for (const skill of skills) {
    const category = skill.category
    if (!groups.has(category)) {
      groups.set(category, {
        category,
        title: category,
        icon: SKILL_GROUP_ICONS[category] || 'scroll-text',
        items: []
      })
    }
    groups.get(category).items.push(skill)
  }

  return [...groups.values()]
}
